 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "src/submodules/base/assets/js/" + ({"lang-de-json":"lang-de-json","lang-es-json":"lang-es-json","lang-fr-json":"lang-fr-json","lang-it-json":"lang-it-json","lang-ja-json":"lang-ja-json","lang-ko-json":"lang-ko-json","lang-pt-json":"lang-pt-json","lang-ru-json":"lang-ru-json","lang-zh-TW-json":"lang-zh-TW-json","lang-zh-json":"lang-zh-json","BaseIcon":"BaseIcon","LoadingComponent":"LoadingComponent","BaseButton":"BaseButton","InputEmailCodeComponent":"InputEmailCodeComponent","BaseSelect":"BaseSelect","PaddlePaymentComponent":"PaddlePaymentComponent","StickerWithTextComponent":"StickerWithTextComponent","NewUserConsentsComponent":"NewUserConsentsComponent","LoginOptionsComponent":"LoginOptionsComponent","BaseCheckBox":"BaseCheckBox","BaseInput":"BaseInput"}[chunkId]||chunkId) + "." + {"chunk-070cfc17":"0b31b433","chunk-14b46c70":"c9eb843e","chunk-2d0b383a":"7d65d3bd","chunk-2d0ce735":"ca817cb7","chunk-2d0d098a":"6c54042e","chunk-2d22bd9d":"53813a5f","chunk-3381604a":"d5738509","chunk-3f0d02bc":"6ce487eb","chunk-573e84fc":"2d142dc1","chunk-3f89b604":"604a75d6","chunk-ef45a3e8":"58878fa6","chunk-58f6be76":"a639c9a3","chunk-5bfd96f7":"c9da7e30","chunk-6408ae22":"a65add2e","chunk-74934650":"853e85f5","chunk-ab0ed4ec":"abc6b44c","chunk-09612b6c":"17e763e3","chunk-15dc04e1":"ab66d898","chunk-19b45338":"e754ebfb","chunk-a60f4ff8":"7dc3c62a","chunk-bdd4b83e":"94c2692d","chunk-c6f2d274":"5dcd2d18","chunk-2ce075ea":"9cda805d","chunk-393d2014":"ca5d3c64","chunk-4bae473d":"74f49bce","chunk-4c4faac6":"4872eb0e","chunk-50526806":"e8b6e8bd","chunk-6a7a4336":"1d55817c","chunk-3c11c78e":"ad37a9d9","chunk-3d138004":"5ea82450","chunk-a7bb12be":"25ba853e","chunk-954ee746":"d7c34e13","chunk-c0769e9a":"440bf5b9","chunk-a7dbc136":"27a7a607","chunk-6a7ca614":"6ca9ea32","chunk-6d8fdbc0":"55df691a","chunk-72ea7e6e":"3fde78ca","chunk-764d06e4":"25596f17","chunk-b0146bde":"7cc88d05","chunk-ba0c6442":"2f16340e","chunk-d1464898":"a1f474c1","chunk-b5266da8":"e4afd0b9","chunk-ff1c5598":"f8fdf504","lang-de-json":"97959bcc","lang-es-json":"f0497fb5","lang-fr-json":"cb3ea1f1","lang-it-json":"eebfa7c3","lang-ja-json":"4e264a8c","lang-ko-json":"f62d1f92","lang-pt-json":"59d181d0","lang-ru-json":"663827c3","lang-zh-TW-json":"d6aa7471","lang-zh-json":"b1023f13","BaseIcon":"0f376022","LoadingComponent":"e4892f0a","BaseButton":"950a4e57","InputEmailCodeComponent":"131b1bce","BaseSelect":"cdd7100b","PaddlePaymentComponent":"71f365c2","StickerWithTextComponent":"1dde3e23","NewUserConsentsComponent":"6923aece","LoginOptionsComponent":"9ffd873d","BaseCheckBox":"22767c22","BaseInput":"3633c8e9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-070cfc17":1,"chunk-14b46c70":1,"chunk-3381604a":1,"chunk-3f0d02bc":1,"chunk-573e84fc":1,"chunk-3f89b604":1,"chunk-ef45a3e8":1,"chunk-58f6be76":1,"chunk-5bfd96f7":1,"chunk-6408ae22":1,"chunk-09612b6c":1,"chunk-15dc04e1":1,"chunk-19b45338":1,"chunk-a60f4ff8":1,"chunk-bdd4b83e":1,"chunk-c6f2d274":1,"chunk-393d2014":1,"chunk-4bae473d":1,"chunk-4c4faac6":1,"chunk-50526806":1,"chunk-6a7a4336":1,"chunk-3c11c78e":1,"chunk-3d138004":1,"chunk-a7bb12be":1,"chunk-954ee746":1,"chunk-c0769e9a":1,"chunk-a7dbc136":1,"chunk-6d8fdbc0":1,"chunk-764d06e4":1,"chunk-b0146bde":1,"chunk-ba0c6442":1,"chunk-d1464898":1,"chunk-b5266da8":1,"chunk-ff1c5598":1,"BaseIcon":1,"LoadingComponent":1,"BaseButton":1,"InputEmailCodeComponent":1,"BaseSelect":1,"PaddlePaymentComponent":1,"StickerWithTextComponent":1,"NewUserConsentsComponent":1,"LoginOptionsComponent":1,"BaseCheckBox":1,"BaseInput":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "src/submodules/base/assets/css/" + ({"lang-de-json":"lang-de-json","lang-es-json":"lang-es-json","lang-fr-json":"lang-fr-json","lang-it-json":"lang-it-json","lang-ja-json":"lang-ja-json","lang-ko-json":"lang-ko-json","lang-pt-json":"lang-pt-json","lang-ru-json":"lang-ru-json","lang-zh-TW-json":"lang-zh-TW-json","lang-zh-json":"lang-zh-json","BaseIcon":"BaseIcon","LoadingComponent":"LoadingComponent","BaseButton":"BaseButton","InputEmailCodeComponent":"InputEmailCodeComponent","BaseSelect":"BaseSelect","PaddlePaymentComponent":"PaddlePaymentComponent","StickerWithTextComponent":"StickerWithTextComponent","NewUserConsentsComponent":"NewUserConsentsComponent","LoginOptionsComponent":"LoginOptionsComponent","BaseCheckBox":"BaseCheckBox","BaseInput":"BaseInput"}[chunkId]||chunkId) + "." + {"chunk-070cfc17":"59076861","chunk-14b46c70":"aa5f89f1","chunk-2d0b383a":"31d6cfe0","chunk-2d0ce735":"31d6cfe0","chunk-2d0d098a":"31d6cfe0","chunk-2d22bd9d":"31d6cfe0","chunk-3381604a":"96ecdd36","chunk-3f0d02bc":"d77c4682","chunk-573e84fc":"38f8b2f3","chunk-3f89b604":"8e5db67f","chunk-ef45a3e8":"2362d1d7","chunk-58f6be76":"82cdf689","chunk-5bfd96f7":"5dc96be1","chunk-6408ae22":"9b0ff836","chunk-74934650":"31d6cfe0","chunk-ab0ed4ec":"31d6cfe0","chunk-09612b6c":"8dbd6780","chunk-15dc04e1":"3a8c2927","chunk-19b45338":"b1333896","chunk-a60f4ff8":"a8a8e19b","chunk-bdd4b83e":"3f85a9b9","chunk-c6f2d274":"08e314cb","chunk-2ce075ea":"31d6cfe0","chunk-393d2014":"86b0b689","chunk-4bae473d":"e5b22073","chunk-4c4faac6":"c6fa10ef","chunk-50526806":"cdb8970f","chunk-6a7a4336":"df86c98a","chunk-3c11c78e":"7988d5b2","chunk-3d138004":"7988d5b2","chunk-a7bb12be":"553dfa45","chunk-954ee746":"34367ecc","chunk-c0769e9a":"4998b114","chunk-a7dbc136":"94d80481","chunk-6a7ca614":"31d6cfe0","chunk-6d8fdbc0":"dc3c01e8","chunk-72ea7e6e":"31d6cfe0","chunk-764d06e4":"dc3c01e8","chunk-b0146bde":"ba16f384","chunk-ba0c6442":"89894e43","chunk-d1464898":"5691e276","chunk-b5266da8":"f65562c8","chunk-ff1c5598":"3f77f354","lang-de-json":"31d6cfe0","lang-es-json":"31d6cfe0","lang-fr-json":"31d6cfe0","lang-it-json":"31d6cfe0","lang-ja-json":"31d6cfe0","lang-ko-json":"31d6cfe0","lang-pt-json":"31d6cfe0","lang-ru-json":"31d6cfe0","lang-zh-TW-json":"31d6cfe0","lang-zh-json":"31d6cfe0","BaseIcon":"8f3af3f7","LoadingComponent":"96ecdd36","BaseButton":"49865200","InputEmailCodeComponent":"91a484bd","BaseSelect":"b561038d","PaddlePaymentComponent":"39f33e6f","StickerWithTextComponent":"f9833f14","NewUserConsentsComponent":"4cb74ec8","LoginOptionsComponent":"198cbb7a","BaseCheckBox":"e9519877","BaseInput":"93ffe2b8"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
